import {
  IconButton,
  Dialog,
  DialogTitle,
  AppBar,
  Toolbar,
  Typography,
  Box,
  CircularProgress,
  DialogContent,
  DialogActions,
  Tooltip,
  Button,
  TextField,
  Autocomplete,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Menu,
  MenuItem,
  ListItem,
  ListItemAvatar,
  Checkbox,
  ListItemText,
  Fab,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";

import axios from "axios";
import moment from "moment";
import defaultPofile from "../../../assets/default-profile.jpg";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import MaskedInput from "react-text-mask";
import joi from "joi";
import { showError } from "../../../toastify";

import PreviewPdfUrl from "../../common/components/PreviewPdfUrl";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const TrainingProviderAttachmentsDialog = (props) => {
  const { user, loading, onWait, trainingProvider } = props;

  const [isLoading, setIsLoading] = useState(true);

  const [showUploadedDocument, setShowUploadedDocument] = useState(false);
  const [uploadedDocument, setUploadedDocument] = useState(null);

  const [attachments, setAttachments] = useState([]);

  const getTrainingProviderAttachments = async () => {
    try {
      setIsLoading(true);

      const { data } = await axios.get(
        `/api/cpd/training-provider-attachments/${trainingProvider.id}`,
      );

      setAttachments(data);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTrainingProviderAttachments();
  }, [trainingProvider]);

  return (
    <>
      <fieldset className={`bg-white mx-0 p-3 rounded border `}>
        <legend
          className={` w-auto px-2 text-primary`}
          style={{
            fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
            fontWeight: 400,
            fontSize: "0.82rem",
            lineHeight: "1em",
            letterSpacing: "0.00938em",
          }}
        >
          Attached documents
        </legend>

        {!!attachments.length ? (
          <div className="row">
            {attachments.map((attachment, index) => (
              <div className="row no-gutters col-12 mb-2" key={attachment.id}>
                <div className="col-12 pr-2">
                  <div
                    className="form-control"
                    style={{
                      backgroundColor: "rgb(229, 246, 253)",
                      color: "#007bff",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setUploadedDocument({
                        name: attachment.description,
                        url: "\\" + attachment.filePath,
                      });
                      setShowUploadedDocument(true);
                    }}
                  >
                    <span className="d-inline-flex align-items-center">
                      <span className="material-icons">attach_file</span>
                      {index + 1}: {attachment.description}
                    </span>

                    <IconButton
                      size="small"
                      onClick={(e) => {
                        setUploadedDocument({
                          name: attachment.description,
                          url: "\\" + attachment.filePath,
                        });
                        setShowUploadedDocument(true);
                      }}
                      style={{
                        marginTop: "-5px",
                        marginRight: "-10px",
                      }}
                      color="info"
                      className="float-right"
                      aria-label="view"
                    >
                      <span className="material-icons">open_in_new</span>
                    </IconButton>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="jumbotron jumbotron-fluid text-center">
            <div className="container">
              <p className="lead">
                {loading ? "Fetching data..." : "No record found"}{" "}
              </p>
            </div>
          </div>
        )}
      </fieldset>

      {showUploadedDocument && uploadedDocument && (
        <PreviewPdfUrl
          isBase64={true}
          showDocument={showUploadedDocument}
          setShowDocument={setShowUploadedDocument}
          document={{
            name: `${uploadedDocument?.name || ""}`,
            url: uploadedDocument?.url || "",
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = ({ user, loading, onWait }) => {
  return {
    user,
    loading,
    onWait,
  };
};
export default connect(mapStateToProps, {})(TrainingProviderAttachmentsDialog);
